import * as React from 'react';
import { generatePath, useHistory } from 'react-router';

import appUrls from 'base/app/urls';
import { PK } from 'common/types';

import { fields, TagsFields } from './consts';
import { useTagsCreate, useTagsUpdate } from './queries';

export const useSave = (pk?: PK) => {
  const [created, setCreated] = React.useState(pk);
  const create = useTagsCreate();
  const update = useTagsUpdate();
  const history = useHistory();

  const isSaving = create.isLoading || update.isLoading;
  const error = create.error || update.error;

  const save = (values: TagsFields) => {
    const payload = {
      name: values[fields.name.name],
    };

    if (created) {
      update.mutate({
        ...payload,
        pk: created,
      });
    } else {
      create.mutate(payload, {
        onSuccess: ({ pk }) => {
          setCreated(pk);
          history.push(generatePath(appUrls.TAGS.DETAILS, { pk }));
        },
      });
    }
  };

  return { save, created, isSaving, error };
};
